<div class="approval-dialog p-4 sm:p-6 font-display bg-white">
  <div class="dialog-header">
    <div class="min-w-0">
      <h2 class="dialog-header__title">Detail approval</h2>
      <p class="dialog-header__subtitle">
        Urutan ke-{{ data.sequence ?? "-" }}
        <ng-container *ngIf="data.approve_at">
          · {{ data.approve_at | date : "d MMM yyyy" }},
          {{ data.approve_at | date : "HH:mm" : "+0700" }} WIB
        </ng-container>
      </p>
    </div>
    <button
      type="button"
      (click)="closeDialog()"
      class="dialog-close"
      aria-label="Tutup"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="info-grid">
    <div class="info-field">
      <span class="info-field__label">Name</span>
      <span class="info-field__value">
        {{ data.user?.firstName }} {{ data.user?.lastName }}
      </span>
    </div>

    <div class="info-field">
      <span class="info-field__label">Employee ID</span>
      <span class="info-field__value">{{ data.user?.employeeId ?? "-" }}</span>
    </div>

    <div class="info-field">
      <span class="info-field__label">Team</span>
      <span class="info-field__value">{{ data.user?.team?.name ?? "-" }}</span>
    </div>

    <div class="info-field">
      <span class="info-field__label">Role</span>
      <span class="info-field__value">{{ data.user?.role?.name ?? "-" }}</span>
    </div>

    <div class="info-field">
      <span class="info-field__label">Sequence</span>
      <span class="info-field__value">{{ data.sequence ?? "-" }}</span>
    </div>

    <div class="info-field">
      <span class="info-field__label">Status</span>
      <span [ngClass]="getStatusClass()">{{ getStatusLabel() }}</span>
    </div>

    <div class="info-field info-field--full">
      <span class="info-field__label">Notes</span>
      <div class="info-field__text-block">
        {{ data.approval_note ?? "-" }}
      </div>
    </div>

    <div class="info-field info-field--full">
      <span class="info-field__label">Lampiran</span>
      <button
        type="button"
        class="attachment-item w-full text-left"
        *ngIf="data.approval_attachment; else noAttachment"
        (click)="download()"
      >
        <span class="attachment-item__name">
          <i class="fa-solid fa-file text-red-500 shrink-0"></i>
          <span class="truncate">{{
            data.approval_attachment?.fileName ?? "Attachment"
          }}</span>
        </span>
        <span class="attachment-item__size">{{
          formatFileSize(data.approval_attachment?.fileSize)
        }}</span>
      </button>
      <ng-template #noAttachment>
        <span class="empty-text">-</span>
      </ng-template>
    </div>
  </div>

  <div class="dialog-footer">
    <button type="button" (click)="closeDialog()" class="btn">Tutup</button>
  </div>
</div>
